import { Form, Input } from "antd";
import { Translate } from "../../translate";
import axios from "../../utils/axios";
import Loading from "../Loading";
import { getStore } from "../../utils/global";
import { forwardRef, useImperativeHandle } from "react";
import { useMutation, useQueryClient } from "react-query";

const Step4 = ({ data }, ref) => {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { isLoading, mutateAsync } = useMutation({
    mutationKey: ["start_signing_process"],
    mutationFn: ({ subject, desc }) => {
      let { docid, txn_id } = data;
      let json = {
        subject: subject,
        desc: desc || "",
        docid: docid,
        txnid: txn_id,
      };
      return axios.post("client/api/doc/startsign", json, { showSuccessMessage: true, showErrorMessage: true });
    },
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.refetchQueries({ queryKey: ["get_doc_list"] });
        queryClient.invalidateQueries({ queryKey: ["get_user_doc_count"] });
        window.location.hash = "#/home";
      }
    },
  });

  useImperativeHandle(ref, () => ({
    finish: () =>
      form
        .validateFields()
        .then((values) => mutateAsync(values))
        .catch((err) => Promise.reject(err)),
  }));

  return (
    <div className="relafull">
      <Loading loading={isLoading} />
      <div className="upload_steps_body">
        <div className="upload_steps_add_rec">
          <div className="upload_steps_add_rec_title">{Translate[ln].NewDoc.Finish.RevnSend}</div>
          <div className="upload_steps_add_rec_title" style={{ fontSize: 18, paddingTop: 0 }}>
            {Translate[ln].NewDoc.Finish.Recip}
          </div>
          <Form form={form} onFinish={mutateAsync} layout="vertical">
            <Form.Item name="subject" label={Translate[ln].NewDoc.Finish.Email} required rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="desc" label={Translate[ln].NewDoc.Finish.EmailMessage}>
              <TextArea rows={5} placeholder="Enter message" />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Step4);
